function showLoginForm() {
	$('.ct-login-info').addClass('hide');
	setTimeout(function() {
		var newOffsetTop = 100,
			calculateOffset,
			currentOffset,
			$contentObj = $('.ct-login-content-wrapper'),
			contentHeight;
	
		$contentObj.css('height','auto');
		contentHeight = $contentObj.css('height','auto').height();
		_logoOffset = contentHeight / 2;
		
		$contentObj.css({
			'top': '50%',
			'margin-top': - _logoOffset + 'px',
			'opacity': 1
		});
	},250);
	setTimeout(function() {
		$('.form-login').addClass('ready');
	},400);
}